import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {JackpotBetWidgetGamesListContainerDefaultBox} from "./jackpot-bet-widget-games-list-container.default.box";
import {JackpotBetWidgetGamesListContainerMRGBox} from "./jackpot-bet-widget-games-list-container.mrgreen.box";
import {JackpotBetWidgetGamesListContainer777Box} from "./jackpot-bet-widget-games-list-container.777.box";

export const JackpotBetWidgetGamesListContainerBox = styledByTheme(JackpotBetWidgetGamesListContainerDefaultBox)
    .forMrGreen(JackpotBetWidgetGamesListContainerMRGBox)
    .forCasino777(JackpotBetWidgetGamesListContainer777Box)
    .apply();